import { observer } from 'mobx-react';
import './Sidebar.scss';
import { sidebarStore } from '../../platform/stores/sidebarStore';
import { gameStore, useTranslation, utilsStore } from '../../platform/stores';
import keno8Logo from '../../assets/images/keno-8-logo.png';
import keno10Logo from '../../assets/images/keno-10-logo.png';

export const Sidebar = observer(() => {
  const t = useTranslation();
  const { gameId, lobbyEnabled } = gameStore;
  const { setShowRulesModal } = utilsStore;
  const { isOpen, setIsOpen } = sidebarStore;
  const games = [
    {
      id: 14,
      name: 'Alchemist\'s Laboratory'
    },
    {
      id: 7,
      name: 'Royal Gold Rush'
    },
    {
      id: 10,
      name: 'Caramel Crush'
    },
    {
      id: 6,
      name: 'Samurai Spin'
    },
    {
      id: 5,
      name: 'Seven Hot Fruits - 5 Line'
    },
    {
      id: 3,
      name: 'Aztec Enigma'
    },
    {
      id: 2,
      name: 'Neo Vegas'
    },
    {
      id: 1,
      name: 'Seven Hot Fruits'
    },
  ];

  if (gameId === 8) {
    games.unshift({
      id: 9,
      name: 'Keno 10'
    })
  } else {
    games.unshift({
      id: 8,
      name: 'Keno 8'
    })
  }

  const openRules = () => {
    setShowRulesModal(true);
    setIsOpen(false);
  }

  const openGame = (id: number) => {
    window.parent.postMessage({ event: 'open-game', data: { id } }, '*');
  }

  return (
    <div className={`sidebar-component ${isOpen ? 'visible' : ''}`}>
      <div className="sidebar-background" onClick={() => setIsOpen(false)}></div>
      <div className="sidebar-container">
        <div className="logo">
          {
            gameId === 8
              ?
              <img src={keno8Logo} alt="Logo"/>
              :
              <img src={keno10Logo} alt="Logo"/>
          }
        </div>
        <div className="sidebar-content">
          <div className="sidebar-btn" onClick={() => openRules()}>{t('RULES')}</div>
          {lobbyEnabled && (
            <div className="games">
              <div className="games-title">Games</div>
              {
                games.map((item) =>
                  <div className="sidebar-btn" key={item.id} onClick={() => openGame(item.id)}>{item.name}</div>
                )
              }
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
